"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- ICON : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'Icon',
  group: _definitionhelpers.groupNames.graphics,
  props: {
    name: {
      type: 'string',
      default: 'arrow-circle-right',
      help: {
        title: 'fontawesome library',
        desc: 'We use this external library of font icons throughout our products. Copy and paste an icon name in this field to see it appear.',
        link: {
          text: 'Visit Library >',
          url: 'https://fontawesome.com/icons?d=gallery&m=free'
        }
      }
    },
    animation: {
      type: 'string',
      default: 'spin',
      help: {
        title: 'fontawesome library',
        desc: 'We use this external library of font icons throughout our products. Copy and paste an animation name in this field to see it appear.',
        link: {
          text: 'Visit Library >',
          url: 'https://fontawesome.com/how-to-use/on-the-web/styling/animating-icons'
        }
      }
    }
  }
};
exports.default = _default;